import React from 'react';
import Skeleton from 'react-loading-skeleton';

import './FuturePaymentsSkeleton.scss';

interface Props {
    count?: number;
    hideTitle?: boolean;
}

export const FuturePaymentAccountNameSkeleton = (): JSX.Element => (
    <div className="future-payments-skeleton">
        <div className="account-name">
            <Skeleton height={24} width={200} />
            <Skeleton height={14} width={150} />
        </div>
    </div>
);

export const FuturePaymentListSkeleton = ({ count = 1, hideTitle = false }: Props): JSX.Element => (
    <div className="future-payments-skeleton">
        <div className="future-payments-list">
            {!hideTitle && <Skeleton className="month-year-label" width={50} height={18} />}
            {Array.from(Array(count)).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="future-payments-list-item" key={index}>
                    <Skeleton height={20} />
                    <Skeleton height={20} />
                </div>
            ))}
        </div>
    </div>
);
